import { FC, useState, useEffect, useRef } from 'react'
import { useInView } from 'framer-motion'
import { LazyVideoProps } from './types'
import { twMerge } from 'tailwind-merge'

export const LazyVideo: FC<LazyVideoProps> = ({ video, className, inView }) => {
  const ref = useRef(null)
  const isInView = useInView(ref, { amount: 0.1 })

  const [videoSrc, setVideoSrc] = useState<
    { url: string; mime_type: string }[] | null
  >(null)
  const [hasLoaded, setHasLoaded] = useState(false)

  useEffect(() => {
    if (isInView || inView) {
      setHasLoaded(true)
    }
  }, [isInView, inView])

  useEffect(() => {
    if (hasLoaded && !videoSrc) {
      setVideoSrc(
        video.sources
          .sort((a, b) => b.height - a.height)
          .map(({ url, mime_type }) => ({ url, mime_type })),
      )
    }
  }, [hasLoaded, video.sources, videoSrc])

  return (
    <div ref={ref} className={twMerge('w-full h-full', className)}>
      <video
        autoPlay
        muted
        loop
        playsInline
        className="w-full h-full object-cover"
        title={video.alt}
        preload="none"
        poster={video.preview_image?.src || undefined}
      >
        {videoSrc &&
          videoSrc.map(({ url, mime_type }, idx) => (
            <source key={idx} src={url} type={mime_type} />
          ))}
      </video>
    </div>
  )
}
